import { portalRoutes } from "@nju/routes";
import { Panel, Separator } from "@nju/ui";
import { RichRow } from "./RichRow";
import { Title } from "./Title";
import { VerifyEmail } from "./VerifyEmail";

interface ILoginInfoProps {
  email: string;
  isEmailVerified: boolean;
}

export function LoginInfo({ email, isEmailVerified }: ILoginInfoProps) {
  return (
    <Panel testId="user-login-details">
      <Title iconName="unlock-alt" title="dane do logowania" />
      <Separator size="s" />
      <RichRow
        id="change-email"
        link={portalRoutes.mojeKonto.mojProfil.zmienAdresEmail.index.get()}
        title={isEmailVerified ? "email" : "potwierdź e-mail"}
        value={email}
      />
      <Separator
        size={{
          "@onlyMobile": "xs",
        }}
        tone="invisible"
      />
      {!isEmailVerified && <VerifyEmail />}
      <Separator size="xs" tone="invisible" />
      <RichRow
        id="change-password"
        link={portalRoutes.mojeKonto.mojProfil.zmienHaslo.get()}
        title="hasło"
        value="*************"
      />
    </Panel>
  );
}
